import { useHandler } from "@redotech/react-util/hook";
import {
  OmsMarketplaceInternalNotesConditionStep,
  OmsOrderNotesConditionStep,
  OmsStreetAddressConditionStep,
} from "@redotech/redo-flows-common/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-flows-common/steps";
import {
  StringMatchOperator,
  stringMatchOperatorToLabel,
  textMatchOperators,
} from "@redotech/redo-flows-core-schema-common/expressions/text-expression";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { DeepPartial } from "..";

const stringMatchOperatorOptions: RedoListItem<StringMatchOperator>[] =
  textMatchOperators.map((type) => ({
    value: type,
    type: "text",
    id: type,
    text: stringMatchOperatorToLabel[type],
  }));

export const StringMatchTypeSelect = memo(function StringMatchTypeSelect({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsStreetAddressConditionStep>
    | DeepPartial<OmsOrderNotesConditionStep>
    | DeepPartial<OmsMarketplaceInternalNotesConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  const { t } = useTranslation();
  const setMatchType = useHandler(
    ({
      item: matchTypeListItem,
    }: {
      item: RedoListItem<StringMatchOperator>;
    }) => {
      setStep({ ...step, matchType: matchTypeListItem.value });
    },
  );
  return (
    <Flex align="center" dir="row" gap="md" wrap="wrap">
      <RedoSingleSelectDropdownInput<StringMatchOperator>
        fitToAnchor={false}
        flexGrow={false}
        options={stringMatchOperatorOptions}
        optionSelected={setMatchType}
        placeholder={t("Select a criteria")}
        selectedItem={stringMatchOperatorOptions.find(
          (o) => o.id === step.matchType,
        )}
        size="xs"
      />
    </Flex>
  );
});
